import { render, staticRenderFns } from "./SendOnechatDetail.vue?vue&type=template&id=6cdc9439&scoped=true&"
import script from "./SendOnechatDetail.vue?vue&type=script&lang=js&"
export * from "./SendOnechatDetail.vue?vue&type=script&lang=js&"
import style0 from "./SendOnechatDetail.vue?vue&type=style&index=0&id=6cdc9439&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdc9439",
  null
  
)

export default component.exports